module.exports = __webpack_public_path__ + "media/public/images/social/twitter-hover-f5cd5f55762028170b0f43d603098e8d.svg";